module.exports = __webpack_public_path__ + "view/img/weixin.bafd25e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/weixin.jpg
// module id = 5M8D
// module chunks = 13